<div class="equity-installment-page">
  <top-bar-tabs></top-bar-tabs>
  <div class="equity-installment-container">
    <mat-drawer-container autosize>
      @if (!isSmallerScreen) {
        <mat-drawer #drawer mode="side" position="end" opened="true">
          <equity-installment-documents-panel (onClose)="drawer.close()"></equity-installment-documents-panel>
        </mat-drawer>
      }
      <div class="container">
        <equity-installment-home [panelExpanded]="drawer ? drawer.opened : bottomPanelExpanded" (expandPanel)="openPanel()" [drawerBottom]="isSmallerScreen" [isSmallerScreen]="isSmallerScreen"></equity-installment-home>
      </div>
    </mat-drawer-container>
  </div>
</div>
<!--<ng-container *ngIf="isSmallerScreen">-->
<!--  <equity-installment-home (expandPanel)="openBottomPanel()"-->
<!--                           [panelExpanded]="bottomPanelExpanded"-->
<!--                           [drawerBottom]="true"-->
<!--                           [isSmallerScreen]="true"-->
<!--                           ></equity-installment-home>-->
<!--&lt;!&ndash;  <div class="bottom-file-drawer-container" *ngIf="bottomPanelExpanded">&ndash;&gt;-->
<!--&lt;!&ndash;    <equity-installment-documents-panel (onClose)="openBottomPanel()"></equity-installment-documents-panel>&ndash;&gt;-->
<!--&lt;!&ndash;  </div>&ndash;&gt;-->
<!--</ng-container>-->
